// extracted by mini-css-extract-plugin
export default {"wrapper":"createCarArea_wrapper__zbj1n","carInputWrapper":"createCarArea_carInputWrapper__Ih8-x","buttonsWrapper":"createCarArea_buttonsWrapper__XEIpw"};